import React from 'react';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/lib/integration/react';
import { persistor, store } from './redux/store/configureStore';
import Main from './screens/Main';
import { ChatCommandProvider } from './context/ChatCommandContext';

function App() {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <ChatCommandProvider>
          <Main />
        </ChatCommandProvider>
      </PersistGate>
    </Provider>
  );
}

export default App;
